<!--
<div class="hero">
    <div class="player" [style.color]="color.primary.s500">
      {{ node.name | translate }}
      <span *ngIf="showPoints" class="points"> ({{ points }}) </span>
    </div>
  </div> -->


<ms-menar-background-hero
  *ngIf="multiController.isAnswerHero && multiController.isHeroVisible"
  [hero]="hero"
  [heroTeacher]="heroTeacher"
></ms-menar-background-hero>

<ng-container *ngIf="multiController.isAnswerExampleVisible">
  <div class="example-fullscreen-wrapper">
    <div
      class="example-fullscreen"
      msOrchestratorBlock="exampleBlock"
      [style.fontSize.px]="multiController.exampleFontSize"
      [ngStyle]="{ color: multiController.operator.appearance.theme.colors.border }"
    >
      {{ multiController.exampleString }}
    </div>
  </div>
</ng-container>

<div class="answer-top" msOrchestratorBlock="resultTop" *ngIf="multiController.isAnswer"></div>

<ms-answer-result-form
  #resultForm
  class="multi-answer-result-form"
  [class.multi-answer-result-form--example-visible]="multiController.isComfortable && multiController.isExampleVisible"
  msOrchestratorBlock="answerResultForm"
  [resultType]="multiController.showResults ? multiController.isCorrect : null"
  [userAnswer]="multiController.userAnswer.value"
  [correctAnswer]="multiController.correctAnswer"
  [duration]="multiController.duration"
  [phrase]="multiController.isAnswerHero ? multiController.phrase : null"
  [uiScale]="multiController.uiScale"
  [resultScale]="multiController.resultScale"
  [canStop]="multiController.canStop"
  [canStart]="multiController.canStart"
  (stop)="multiController.stop()"
  (play)="multiController.play()"
>
  <!-- Кнопка показа/скрытия примера — как в Форсаже/Столбиках, тот же источник размеров, что у stop/next.
       Только комфортный режим: в атмосферном/домашке пример виден сразу. -->
  @if (multiController.isComfortable) {
  <button
    msExtraGameButton
    msGameButton
    [color]="'blue'"
    [sizes]="resultForm.buttonSizes"
    (click)="multiController.toggleExampleVisibility()"
    [attr.aria-label]="(multiController.isExampleVisible ? 'games.common.hideExample' : 'games.common.showExample') | translate"
  >
    <svg class="example-toggle-button__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path *ngIf="!multiController.isExampleVisible" d="M12 5C7 5 2.73 8.11 1 12.5 2.73 16.89 7 20 12 20s9.27-3.11 11-7.5C21.27 8.11 17 5 12 5zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
      <path *ngIf="multiController.isExampleVisible" d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="currentColor"/>
    </svg>
  </button>
  }
</ms-answer-result-form>
